import { render, staticRenderFns } from "./mokaoScore.vue?vue&type=template&id=64bd6d4b&scoped=true"
import script from "./mokaoScore.vue?vue&type=script&lang=js"
export * from "./mokaoScore.vue?vue&type=script&lang=js"
import style0 from "./mokaoScore.vue?vue&type=style&index=0&id=64bd6d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd6d4b",
  null
  
)

export default component.exports